<template>
  <div>
    <div align="left">
      <h5 class="h5 mb-3 text-primary font-weight-bold">Event</h5>
    </div>
    <br />
    <b-card class="text-left">
      <h5 class="font-weight-bold text-primary">Edit Event</h5>
      <br />
      <br />
      <b-row>
        <b-col>
          <div>
            <b-tabs content-class="mt-3" justified>
              <b-tab
                title="Paxelpreneur"
                :active="items.type == 'paxel_preneur'"
                :disabled="items.type != 'paxel_preneur'"
              >
                <app-paxelpreneur v-if="items.type == 'paxel_preneur'" :items="items"></app-paxelpreneur>
              </b-tab>
              <b-tab
                title="Business Consultation"
                :active="items.type == 'business_consultation'"
                :disabled="items.type != 'business_consultation'"
              >
                <app-business-consultation v-if="items.type == 'business_consultation'" :items="items"></app-business-consultation>
              </b-tab>
              <b-tab
                title="#AntarkanKebaikan"
                :active="items.type == 'antarkankebaikan'"
                :disabled="items.type != 'antarkankebaikan'"
              >
                <app-Antarkankebaikan v-if="items.type == 'antarkankebaikan'" :items="items"></app-Antarkankebaikan>
              </b-tab>
            </b-tabs>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import Paxelpreneur from '../component/PaxelpreneurEdit';
import BusinessConsultation from '../component/BusinessConsultationEdit';
import Antarkankebaikan from '../component/antarkankebaikanEdit';

export default {
  components: {
    appPaxelpreneur: Paxelpreneur,
    appBusinessConsultation: BusinessConsultation,
    appAntarkankebaikan: Antarkankebaikan,
  },
  data() {
    return {
      items: {
          id: "",
          location: "",
          contents: {
              en: "",
              id: ""
          },
          image_url: "",
          link_url: "",
          membership_types: "",
          pic_contact: "",
          pic_name: "",
          titles: {
              en: "",
              id: ""
          },
          type: "",
          valid_until: ""
      },
    };
  },
  beforeMount() {
    this.items = this.$route.params.id
    if (this.items && typeof this.items.valid_until == "string") {
      this.items.valid_until = moment(this.items.valid_until, "DD-MM-YYYY HH:mm").toDate();
    }
  },
  methods: {},
};
</script>

<style scoped>
</style>
